import _ from 'lodash';
import NextMixinCan from '@/components/mixins/NextMixinCan';
import NextMixinGetItem from '@/components/mixins/NextMixinGetItem';

export default {
    mixins: [NextMixinCan, NextMixinGetItem],
    data() {
        return {
            form: {},
            item: null,
            keyForm: 1,
            loading: false,
            moduleActions: [],
            subtitle: '',
            help: null,
            tutorial: null,
            breadcrumbs: [],
            mapManageActions: {}
        }
    },
    //props: ['itemId'],
    mounted() {
        //this.loadItem();
        this.mapManageActions['create'] = this.manageCreate;
        this.mapManageActions['edit'] = this.manageEdit;
        this.mapManageActions['copy'] = this.manageCopy;
        this.manageAction();
        this.breadcrumbsInit();
    },
    watch: {
        item: {
            deep: true,
            handler() {
                this.renderTitle();
            }
        },

        '$route': function (newRoute, oldRoute) {
            this.$refs.form.loadForm({});
            this.manageAction();
        }

    },
    methods: {
        track() {
            this.$gtag.pageview(this.$route);
        },
        renderTitle() {
            if (this.item) {
                if (this.itemToTitle) {
                    this.itemToTitle(this.item);
                } else {
                    this.title = "Actualizar";
                    if (this.name) {
                        this.title = ' - ' + this.name;
                    } else {
                        this.title = ' - ' + this.id;
                    }
                }
            }
        },

        breadcrumbsInit() {
            this.breadcrumbs.push({
                text: this.$t('home'),
                disabled: false,
                href: "/admin"
            });
        },
        /* This method is used to define specific actions according to the purpose to be achieved. 
        By default, the "create" action is taken. If an ID is given, the context is for an update. 
        If an "action" parameter is sent, according to the value of this parameter, 
        a specific action will be executed. The action is specified as a query parameter, "?action=copy".
        */
        manageAction() {
            let actionName = this.getActionName();
            this.executeManageAction(actionName);
        },
        manageCreate() {

        },
        manageEdit() {
            const id = this.$route.params.id;
            this.loading = true;
            this.getItem(this.getUrlGet() + '/' + id).then(data => {
                this.item = data.item;
                this.moduleActions = data.module_actions;
                this.$refs.form.loadForm(JSON.parse(JSON.stringify(data.item)));
                this.loading = false;
                this.renderTitle();
            }).catch(e => {
                this.loading = false;
            });
        },
        manageCopy() {
            //console.log(this.$route)
            const id = this.$route.query.id;
            this.loading = true;
            this.getItem(this.getUrlGet() + '/' + id + '/copy').then(data => {
                this.item = data.item;
                this.moduleActions = data.module_actions;
                this.$refs.form.loadForm(JSON.parse(JSON.stringify(data.item)));
                this.loading = false;
            }).catch(e => {
                this.loading = false;
            });
        },
        executeManageAction(actionName) {
            this.mapManageActions[actionName]();
        },
        getActionName() {
            if (this.$route.query.action) {
                return this.$route.query.action;
            }
            if (this.$route.params.id) {
                return 'edit';
            }
            return 'create';
        },
        updateItemFromResponse(response) {
            console.log(response)
            if (response.item) {
                this.item = response.item;
            }
            if (response.moduleActions) {
                this.moduleActions = response.moduleActions;
            }
        },

        cancel() {
            this.$router.go(-1);
        },

        getUrlGet() {
            return this.urlGet;
        },

        executeCreate() {
            this.item = null;
            //this.clean();
            if (this.$route.params.id) {
                this.$router.push(this.pathCreate);
            } else {

            }
        }
    }
}
